import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { MarketingLayout } from "~/app/components/landing/marketing-layout";
import { t } from "~/app/i18n";
import privacyPolicyMarkdown from "../../static/privacy-policy.md?raw";
import type { Route } from "./+types/privacy-policy";

export async function loader(_args: Route.LoaderArgs) {
  return { markdown: privacyPolicyMarkdown };
}

export default function PrivacyPolicy({ loaderData }: Route.ComponentProps) {
  return (
    <MarketingLayout>
      <div className="container mx-auto px-4 py-16 md:py-24 max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900 mb-12">
          {t("Landing.footer.privacyPolicy")}
        </h1>
        <div className="prose prose-slate max-w-none prose-headings:font-semibold prose-headings:tracking-tight prose-headings:text-slate-900 prose-p:text-slate-500 prose-p:font-light prose-p:leading-relaxed prose-li:text-slate-500 prose-li:font-light prose-strong:text-slate-700 prose-strong:font-medium prose-a:text-brand-600 prose-a:no-underline hover:prose-a:text-brand-700 prose-h1:hidden prose-h2:text-xl prose-h2:md:text-2xl prose-h3:text-lg prose-h3:md:text-xl">
          <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
            {loaderData.markdown}
          </Markdown>
        </div>
      </div>
    </MarketingLayout>
  );
}
